import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  pt: {
    translation: {
      language: {
        selector: 'Seletor de idioma',
        portuguese: 'Português',
        english: 'Inglês',
      },
      nav: {
        about: 'Como funciona',
        projects: 'Sistemas e projetos',
        applications: 'Aplicações',
        advantages: 'Vantagens',
        contact: 'Contactos',
      },
      hero: {
        eyebrow: 'Tratamento e reutilização de água',
        title: 'Reutilização de água para operações mais eficientes',
        description: 'Desenvolvemos sistemas modulares para tratar e reutilizar águas residuais em aplicações industriais, comerciais e urbanas.',
        primaryCta: 'Fale connosco',
        secondaryCta: 'Os nossos sistemas',
        impact: {
          prefix: 'Pelo menos',
          label: 'de reutilização da água cinzenta',
        },
      },
      about: {
        eyebrow: 'Como funciona',
        title: 'Da água residual à reutilização, em três etapas',
        introduction: 'A Ambitus desenvolve e monitoriza sistemas modulares que combinam oxidação catalítica heterogénea avançada com etapas de filtração adequadas a cada projeto.',
        steps: {
          collect: {
            title: 'Recolher',
            description: 'A água residual do circuito é encaminhada para o sistema de tratamento.',
          },
          treat: {
            title: 'Tratar',
            description: 'A oxidação catalítica e a filtração atuam sobre os contaminantes presentes na água.',
          },
          reuse: {
            title: 'Reutilizar',
            description: 'A água tratada regressa ao circuito para uma utilização adequada ao projeto.',
          },
        },
      },
      projects: {
        eyebrow: 'Projetos reais',
        title: 'Sistemas Ambitus em operação',
        introduction: 'Explore algumas instalações reais onde os sistemas Ambitus estão atualmente em funcionamento.',
        carouselLabel: 'Sistemas Ambitus em funcionamento',
        previous: 'Sistema anterior',
        next: 'Sistema seguinte',
        slideLabel: 'Sistema {{current}} de {{total}}',
        slideNavigation: 'Selecionar sistema',
        goToProject: 'Ver {{project}}',
        items: {
          usibras: {
            name: 'Usibras',
            location: 'Fortaleza, Brasil',
            category: 'Instalação industrial',
            description: 'Sistema Ambitus em operação na Usibras, Fortaleza, Brasil.',
            caption: 'Instalação real · Usibras · Fortaleza, Brasil',
            imageAlt: 'Sistema Ambitus na Usibras com três reatores catalíticos e três unidades de filtração por membranas',
            highlights: [
              'Capacidade até 15 m³/h',
              'Sistema atualmente em funcionamento',
            ],
          },
          jetwashRegua: {
            name: 'Jetwash Régua',
            location: 'Régua, Vila Real, Portugal',
            category: 'Lavagem automóvel',
            description: 'O equipamento de oxidação catalítica avançada instalado na Jetwash da Régua trata contaminantes orgânicos e inorgânicos, permitindo reutilizar a água na própria instalação.',
            caption: 'Instalação real · Jetwash · Régua, Vila Real',
            imageAlt: 'Equipamento Ambitus de oxidação catalítica avançada instalado na Jetwash da Régua',
            highlights: [
              'Capacidade até 2 m³/h',
              'Sistema atualmente em funcionamento',
            ],
          },
          lubricantPanama: {
            name: 'Refinação de óleo lubrificante',
            location: 'Panamá',
            category: 'Tratamento industrial',
            description: 'Sistema Ambitus instalado numa unidade da indústria de refinação de óleo lubrificante no Panamá.',
            caption: 'Instalação real · Refinação de óleo lubrificante · Panamá',
            exteriorLabel: 'Exterior',
            interiorLabel: 'Interior',
            exteriorImageAlt: 'Vista exterior do sistema Ambitus instalado numa unidade de refinação de óleo lubrificante no Panamá',
            interiorImageAlt: 'Equipamento de tratamento Ambitus no interior do sistema instalado no Panamá',
            highlights: [
              'Capacidade de 20 m³/dia',
              'Sistema atualmente em funcionamento',
            ],
          },
          swineAgriculture: {
            name: 'Tratamento de dejetos suínos',
            category: 'Indústria suína',
            description: 'Sistema Ambitus aplicado ao tratamento de dejetos provenientes da indústria suína.',
            caption: 'Instalação real · Indústria suína',
            imageAlt: 'Sistema Ambitus para tratamento de dejetos da indústria suína com torre de oxidação avançada',
            highlights: [
              'Capacidade de 40 m³/dia',
              'Sistema atualmente em funcionamento',
            ],
          },
        },
      },
      advantages: {
        eyebrow: 'Principais vantagens',
        title: 'Concebido para operar com eficiência e controlo',
        introduction: 'Cada sistema é dimensionado para as necessidades da instalação e acompanhado ao longo da sua operação.',
        items: {
          reuse: {
            title: 'Pelo menos 85% de reutilização',
            description: 'Os sistemas Ambitus reutilizam, no mínimo, 85% da água cinzenta tratada.',
          },
          modular: {
            title: 'Configuração modular',
            description: 'Os módulos são dimensionados e combinados de acordo com o caudal, o espaço disponível e as necessidades de cada instalação.',
          },
          monitoring: {
            title: 'Monitorização em tempo real',
            description: 'Sensores acompanham parâmetros da água e o funcionamento do equipamento durante a operação.',
          },
          support: {
            title: 'Acompanhamento remoto',
            description: 'A supervisão remota permite acompanhar o sistema e responder com maior rapidez a necessidades técnicas.',
          },
        },
      },
      applications: {
        eyebrow: 'Mercados que servimos',
        title: 'Soluções para diferentes contextos de utilização',
        introduction: 'Adaptamos o tratamento ao tipo de instalação, ao circuito de água e aos objetivos de reutilização de cada projeto.',
        items: {
          condominiums: {
            title: 'Condomínios',
            description: 'Reutilização de água em edifícios residenciais e respetivas zonas comuns.',
            imageAlt: 'Edifício residencial com espaços verdes',
          },
          laundries: {
            title: 'Lavandarias',
            description: 'Tratamento para operações com consumo recorrente de água em ciclos de lavagem.',
            imageAlt: 'Equipamento de uma lavandaria',
          },
          hospitals: {
            title: 'Instalações de saúde',
            description: 'Sistemas dimensionados para as necessidades e os circuitos definidos em cada instalação.',
            imageAlt: 'Edifício de uma instalação de saúde',
          },
          industries: {
            title: 'Indústria',
            description: 'Tratamento e reutilização de água adaptados aos processos e caudais industriais.',
            imageAlt: 'Instalação industrial',
          },
          carWashes: {
            title: 'Lavagem automóvel',
            description: 'Reutilização de água no circuito tratado de instalações de lavagem automóvel.',
            imageAlt: 'Automóvel numa instalação de lavagem',
          },
          agriculture: {
            title: 'Agricultura',
            description: 'Tratamento de água dimensionado para aplicações agrícolas adequadas ao projeto.',
            imageAlt: 'Vinha num contexto agrícola',
          },
        },
      },
      contact: {
        eyebrow: 'Fale connosco',
        title: 'Vamos avaliar o seu projeto',
        introduction: 'Partilhe connosco o contexto da sua instalação e os objetivos de reutilização. Entraremos em contacto para perceber as necessidades do projeto.',
        directLabel: 'Contacto direto',
        formTitle: 'Conte-nos o que pretende tratar',
        name: 'Nome',
        email: 'Email',
        company: 'Empresa',
        optional: '(opcional)',
        message: 'Mensagem',
        messagePlaceholder: 'Tipo de instalação, caudal aproximado e objetivo de reutilização',
        submit: 'Preparar email',
        privacyNote: 'Ao continuar, será aberto o seu programa de email. Nenhum dado é guardado neste site.',
        prepared: 'O email foi preparado. Confirme o envio no seu programa de email.',
        composeError: 'Não foi possível abrir o programa de email. Utilize o contacto direto apresentado ao lado.',
        validation: {
          required: 'Campo obrigatório',
          email: 'Introduza um email válido',
          summary: 'Verifique os campos assinalados antes de continuar.',
        },
        emailContent: {
          subject: 'Pedido de avaliação Ambitus — {{name}}',
        },
      },
      footer: {
        tagline: 'Transformando Água Residual num Futuro Sustentável',
        usefulLinks: 'Navegação',
        navigationLabel: 'Navegação no rodapé',
        legislation: 'Legislação',
        contacts: 'Contactos',
        cookieSettings: 'Preferências de cookies',
        copyright: 'Ambitus Strategy, Lda. Todos os direitos reservados.',
      },
      cookies: {
        eyebrow: 'Privacidade',
        title: 'Podemos medir a utilização do site?',
        description: 'Utilizamos Google Analytics apenas com a sua autorização para perceber como o site é utilizado. Não utilizamos cookies publicitários. Pode alterar esta escolha no rodapé.',
        googlePrivacy: 'Privacidade na Google',
        reject: 'Recusar métricas',
        accept: 'Aceitar métricas',
        keep: 'Manter preferência',
      },
      boards: {
        homeLabel: 'Ambitus Strategy — página inicial',
        status: 'Ambitus Boards',
        title: 'Brevemente',
        description: 'Estamos a preparar uma nova área para acompanhar os nossos sistemas de reutilização de água.',
        backHome: 'Voltar à página inicial',
      },
    },
  },
  en: {
    translation: {
      language: {
        selector: 'Language selector',
        portuguese: 'Portuguese',
        english: 'English',
      },
      nav: {
        about: 'How it works',
        projects: 'Systems & projects',
        applications: 'Applications',
        advantages: 'Benefits',
        contact: 'Contact',
      },
      hero: {
        eyebrow: 'Water treatment and reuse',
        title: 'Water reuse for more efficient operations',
        description: 'We develop modular systems to treat and reuse wastewater across industrial, commercial and urban applications.',
        primaryCta: 'Talk to us',
        secondaryCta: 'Our systems',
        impact: {
          prefix: 'At least',
          label: 'greywater reuse',
        },
      },
      about: {
        eyebrow: 'How it works',
        title: 'From wastewater to reuse in three steps',
        introduction: 'Ambitus develops and monitors modular systems that combine advanced heterogeneous catalytic oxidation with filtration stages tailored to each project.',
        steps: {
          collect: {
            title: 'Collect',
            description: 'Wastewater from the loop is directed to the treatment system.',
          },
          treat: {
            title: 'Treat',
            description: 'Catalytic oxidation and filtration act on the contaminants present in the water.',
          },
          reuse: {
            title: 'Reuse',
            description: 'The treated water returns to the loop for a use suited to the project.',
          },
        },
      },
      projects: {
        eyebrow: 'Real projects',
        title: 'Ambitus systems in operation',
        introduction: 'Explore real installations where Ambitus systems are currently operating.',
        carouselLabel: 'Operating Ambitus systems',
        previous: 'Previous system',
        next: 'Next system',
        slideLabel: 'System {{current}} of {{total}}',
        slideNavigation: 'Select a system',
        goToProject: 'View {{project}}',
        items: {
          usibras: {
            name: 'Usibras',
            location: 'Fortaleza, Brazil',
            category: 'Industrial installation',
            description: 'Ambitus system in operation at Usibras, Fortaleza, Brazil.',
            caption: 'Real installation · Usibras · Fortaleza, Brazil',
            imageAlt: 'Ambitus system at Usibras with three catalytic reactors and three membrane filtration units',
            highlights: [
              'Capacity up to 15 m³/h',
              'System currently operating',
            ],
          },
          jetwashRegua: {
            name: 'Jetwash Régua',
            location: 'Régua, Vila Real, Portugal',
            category: 'Car wash',
            description: 'The advanced catalytic oxidation equipment installed at Jetwash Régua treats organic and inorganic contaminants, allowing water to be reused within the facility.',
            caption: 'Real installation · Jetwash · Régua, Vila Real',
            imageAlt: 'Ambitus advanced catalytic oxidation equipment installed at Jetwash Régua',
            highlights: [
              'Capacity up to 2 m³/h',
              'System currently operating',
            ],
          },
          lubricantPanama: {
            name: 'Lubricating oil refining',
            location: 'Panama',
            category: 'Industrial treatment',
            description: 'Ambitus system installed at a lubricating-oil refining facility in Panama.',
            caption: 'Real installation · Lubricating oil refining · Panama',
            exteriorLabel: 'Exterior',
            interiorLabel: 'Interior',
            exteriorImageAlt: 'Exterior view of the Ambitus system installed at a lubricating-oil refining facility in Panama',
            interiorImageAlt: 'Ambitus treatment equipment inside the system installed in Panama',
            highlights: [
              'Capacity of 20 m³/day',
              'System currently operating',
            ],
          },
          swineAgriculture: {
            name: 'Swine-waste treatment',
            category: 'Swine industry',
            description: 'Ambitus system applied to the treatment of waste from the swine industry.',
            caption: 'Real installation · Swine industry',
            imageAlt: 'Ambitus swine-waste treatment system with an advanced oxidation tower',
            highlights: [
              'Capacity of 40 m³/day',
              'System currently operating',
            ],
          },
        },
      },
      advantages: {
        eyebrow: 'Key benefits',
        title: 'Designed for efficient, controlled operation',
        introduction: 'Each system is sized for the installation and supported throughout its operation.',
        items: {
          reuse: {
            title: 'At least 85% reuse',
            description: 'Ambitus systems reuse at least 85% of the treated greywater.',
          },
          modular: {
            title: 'Modular configuration',
            description: 'Modules are sized and combined according to flow rate, available space and the needs of each installation.',
          },
          monitoring: {
            title: 'Real-time monitoring',
            description: 'Sensors track water parameters and equipment operation while the system is running.',
          },
          support: {
            title: 'Remote support',
            description: 'Remote supervision helps us monitor the system and respond more quickly to technical needs.',
          },
        },
      },
      applications: {
        eyebrow: 'Markets we serve',
        title: 'Solutions for different operating contexts',
        introduction: 'We adapt treatment to the installation, the water loop and each project’s reuse objectives.',
        items: {
          condominiums: {
            title: 'Residential buildings',
            description: 'Water reuse in residential buildings and their shared areas.',
            imageAlt: 'Residential building with landscaped areas',
          },
          laundries: {
            title: 'Laundries',
            description: 'Treatment for operations with recurring water consumption across washing cycles.',
            imageAlt: 'Laundry equipment',
          },
          hospitals: {
            title: 'Healthcare facilities',
            description: 'Systems sized for the needs and water loops defined for each facility.',
            imageAlt: 'Healthcare facility building',
          },
          industries: {
            title: 'Industry',
            description: 'Water treatment and reuse adapted to industrial processes and flow rates.',
            imageAlt: 'Industrial facility',
          },
          carWashes: {
            title: 'Car washes',
            description: 'Water reuse within the treated loop of car-wash facilities.',
            imageAlt: 'Vehicle at a car-wash facility',
          },
          agriculture: {
            title: 'Agriculture',
            description: 'Water treatment sized for agricultural applications suited to the project.',
            imageAlt: 'Vineyard in an agricultural setting',
          },
        },
      },
      contact: {
        eyebrow: 'Talk to us',
        title: 'Let’s assess your project',
        introduction: 'Tell us about your installation and reuse objectives. We will get in touch to understand the project requirements.',
        directLabel: 'Direct contact',
        formTitle: 'Tell us what you need to treat',
        name: 'Name',
        email: 'Email',
        company: 'Company',
        optional: '(optional)',
        message: 'Message',
        messagePlaceholder: 'Installation type, approximate flow rate and reuse objective',
        submit: 'Prepare email',
        privacyNote: 'Continuing will open your email application. No data is stored on this website.',
        prepared: 'Your email is ready. Please confirm sending it in your email application.',
        composeError: 'We could not open your email application. Please use the direct email address shown alongside the form.',
        validation: {
          required: 'Required field',
          email: 'Enter a valid email address',
          summary: 'Check the highlighted fields before continuing.',
        },
        emailContent: {
          subject: 'Ambitus project enquiry — {{name}}',
        },
      },
      footer: {
        tagline: 'Turning Wastewater into a Sustainable Future',
        usefulLinks: 'Navigation',
        navigationLabel: 'Footer navigation',
        legislation: 'Legislation',
        contacts: 'Contact',
        cookieSettings: 'Cookie preferences',
        copyright: 'Ambitus Strategy, Lda. All rights reserved.',
      },
      cookies: {
        eyebrow: 'Privacy',
        title: 'May we measure website usage?',
        description: 'We use Google Analytics only with your permission to understand how the website is used. We do not use advertising cookies. You can change this choice in the footer.',
        googlePrivacy: 'Google Privacy Policy',
        reject: 'Reject analytics',
        accept: 'Accept analytics',
        keep: 'Keep preference',
      },
      boards: {
        homeLabel: 'Ambitus Strategy — home page',
        status: 'Ambitus Boards',
        title: 'Coming up soon',
        description: 'We are preparing a new area where you will be able to follow our water reuse systems.',
        backHome: 'Back to the home page',
      },
    },
  },
};

const savedLanguage = window.localStorage.getItem('ambitus-language');
const initialLanguage = ['pt', 'en'].includes(savedLanguage) ? savedLanguage : 'pt';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

document.documentElement.lang = initialLanguage;

export default i18n;
